export const TABLE_EVENT_TYPE = {
    CLICK_CELL: "click_cell",
    DBLCLICK_CELL: "dblclick_cell",
    MOUSEDOWN_CELL: "mousedown_cell",
    MOUSEUP_CELL: "mouseup_cell",
    SELECTED_CELL: "selected_cell",
    SELECTED_CLEAR: "selected_clear",
    KEYDOWN: "keydown",
    MOUSEENTER_TABLE: "mouseenter_table",
    MOUSELEAVE_TABLE: "mouseleave_table",
    MOUSEDOWN_TABLE: "mousedown_table",
    MOUSEMOVE_TABLE: "mousemove_table",
    MOUSEMOVE_CELL: "mousemove_cell",
    MOUSEENTER_CELL: "mouseenter_cell",
    MOUSELEAVE_CELL: "mouseleave_cell",
    CONTEXTMENU_CELL: "contextmenu_cell",
    RESIZE_COLUMN: "resize_column",
    RESIZE_COLUMN_END: "resize_column_end",
    RESIZE_ROW: "resize_row",
    RESIZE_ROW_END: "resize_row_end",
    CHANGE_HEADER_POSITION_START: "change_header_position_start",
    CHANGE_HEADER_POSITION: "change_header_position",
    CHANGING_HEADER_POSITION: "changing_header_position",
    CHANGE_HEADER_POSITION_FAIL: "change_header_position_fail",
    SORT_CLICK: "sort_click",
    AFTER_SORT: "after_sort",
    FREEZE_CLICK: "freeze_click",
    SCROLL: "scroll",
    SCROLL_HORIZONTAL_END: "scroll_horizontal_end",
    SCROLL_VERTICAL_END: "scroll_vertical_end",
    DROPDOWN_MENU_CLICK: "dropdown_menu_click",
    MOUSEOVER_CHART_SYMBOL: "mouseover_chart_symbol",
    DRAG_SELECT_END: "drag_select_end",
    COPY_DATA: "copy_data",
    DROPDOWN_ICON_CLICK: "dropdown_icon_click",
    DROPDOWN_MENU_CLEAR: "dropdown_menu_clear",
    TREE_HIERARCHY_STATE_CHANGE: "tree_hierarchy_state_change",
    SHOW_MENU: "show_menu",
    HIDE_MENU: "hide_menu",
    ICON_CLICK: "icon_click",
    LEGEND_ITEM_CLICK: "legend_item_click",
    LEGEND_ITEM_HOVER: "legend_item_hover",
    LEGEND_ITEM_UNHOVER: "legend_item_unHover",
    LEGEND_CHANGE: "legend_change",
    MOUSEENTER_AXIS: "mouseenter_axis",
    MOUSELEAVE_AXIS: "mouseleave_axis",
    CHECKBOX_STATE_CHANGE: "checkbox_state_change",
    RADIO_STATE_CHANGE: "radio_state_change",
    AFTER_RENDER: "after_render",
    INITIALIZED: "initialized",
    CHANGE_CELL_VALUE: "change_cell_value",
    DRAG_FILL_HANDLE_END: "drag_fill_handle_end",
    MOUSEDOWN_FILL_HANDLE: "mousedown_fill_handle",
    DBLCLICK_FILL_HANDLE: "dblclick_fill_handle",
    EMPTY_TIP_CLICK: "empty_tip_click",
    EMPTY_TIP_DBLCLICK: "empty_tip_dblclick"
};
//# sourceMappingURL=TABLE_EVENT_TYPE.js.map